import React from 'react';
import EntityMultiSelect, { selectedEntityIds } from '../../../../shared/components/EntityMultiSelect';
import { PartyField } from '../../../../shared/components/PartyFormFields';
import { AccountingAmountField } from '../shared/AccountingFormFields';

export default function PaymentFormFields({ form, update, selectClients, clients = [], isSubmitting = false,
  editing = false, linked = false, titleField = 'description', dateField = 'date' }) {
  return <>
      <PartyField id="immediate-payment-description" label="Titolo" required maxLength={255} value={form[titleField]}
        onChange={value => update(titleField, value)} placeholder="Inserisci titolo..." disabled={isSubmitting} />
      <PartyField id="immediate-payment-notes" label="Descrizione" required={!editing} multiline rows={3} value={form.notes}
        onChange={value => update('notes', value)} placeholder="Inserisci descrizione..." disabled={isSubmitting} />
      <div className="party-form__row">
        <PartyField id="immediate-payment-reason" label="Causale" required={!editing} maxLength={1000} value={form.reason}
          onChange={value => update('reason', value)} placeholder="Esempio: Saldo Fattura n. 45" disabled={isSubmitting} />
        <div className="party-form__field">
          <label htmlFor="immediate-payment-client">Cliente *</label>
          <EntityMultiSelect id="immediate-payment-client" label="Clienti" required options={clients}
            value={selectedEntityIds(form, 'client')} onChange={selectClients} disabled={isSubmitting || linked || !clients.length} />
        </div>
      </div>
      <div className="party-form__row">
        <PartyField id="immediate-payment-date" label={dateField === "dueDate" ? "Scadenza" : "Data pagamento"} required type="date" value={form[dateField]}
          onChange={value => update(dateField, value)} disabled={isSubmitting} />
        <AccountingAmountField id="immediate-payment-amount" value={form.amount} onChange={value => update('amount', value)} disabled={isSubmitting} readOnly={linked} />
      </div>
  </>;
}
